








import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({})
export default class ActionLinkComponent extends Vue {
    @Prop() public title: string;
    @Prop() public disabled: boolean;

    public click() {
        // TODO not need if you use button instead of <a>
        if (this.disabled) {
            return;
        }
        this.$emit('click');
    }
}
